import { APPROVAL_DESK, UNAUTHORIZED_PATH } from '@atlassian/cssxp-typescommon';

//export const APPROVAL_DESK_PATH = 'approval-desk';
export const TASK_MANAGER_PATH = 'tasks';
export const PROCESS_MANAGER_PATH = 'admin';
export const PARAM_TASK_ID = 'taskId';
export const ADMIN_REPORT_PATH = 'report';

export const getUnAuthorizedPath = () => {
  return UNAUTHORIZED_PATH;
};

export const getApprovalDeskPath = () => {
  return APPROVAL_DESK;
};

export const getTaskManagerPath = () => {
  return `${APPROVAL_DESK}/${TASK_MANAGER_PATH}`;
};

export const getTaskPath = (taskId: string) => {
  return `${APPROVAL_DESK}/${TASK_MANAGER_PATH}/${taskId}`;
};

export const getTaskRoutePath = () => {
  return `${APPROVAL_DESK}/${TASK_MANAGER_PATH}/:${PARAM_TASK_ID}?`;
};

export const getProcessManagerPath = () => {
  return `${APPROVAL_DESK}/${PROCESS_MANAGER_PATH}`;
};

export const getProcessManagerReportPath = () => {
  return `${APPROVAL_DESK}/${PROCESS_MANAGER_PATH}/${ADMIN_REPORT_PATH}`;
};

export const getAdminTaskManagerPath = () => {
  return `${APPROVAL_DESK}/${PROCESS_MANAGER_PATH}/${TASK_MANAGER_PATH}`;
};

export const getAdminTaskPath = (taskId: string) => {
  return `${APPROVAL_DESK}/${PROCESS_MANAGER_PATH}/${TASK_MANAGER_PATH}/${taskId}`;
};

export const getAdminTaskRoutePath = () => {
  return `${APPROVAL_DESK}/${PROCESS_MANAGER_PATH}/${TASK_MANAGER_PATH}/:${PARAM_TASK_ID}?`;
};
